import moment from 'moment';
import { SubmissionFormWrapper, SubmissionList } from './types';

export const getId = (record: SubmissionList | SubmissionFormWrapper | undefined) => {
  if (record == undefined) return '-';
  return moment(record.createdAt).format('YYMMDD') + String(record.id).padStart(4, '0');
};
